module.exports = __webpack_public_path__ + "static/media/59.2dca6bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/59.png
// module id = 632
// module chunks = 0